function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import container from 'di/inversify.config';
import TYPES from 'di/types';
import numberFormat from 'number_format-php';
import { ExternalApp } from 'moduleBase/entities/ExternalApp';

var App = /*#__PURE__*/function () {
  function App(translate, user) {
    _classCallCheck(this, App);

    _defineProperty(this, "lang", process.env.LANG_DEFAULT);

    this.translate = translate;
    this.user = user;
    this.externalApp = new ExternalApp();
    this.translate.setLang(this.lang);
  }

  _createClass(App, [{
    key: "getTranslate",
    value: function getTranslate() {
      return this.translate;
    }
  }, {
    key: "setLang",
    value: function setLang(lang) {
      this.lang = lang;
      this.translate.setLang(this.lang);
      return this;
    }
  }, {
    key: "getLang",
    value: function getLang() {
      return this.lang;
    }
  }, {
    key: "getExternalApp",
    value: function getExternalApp() {
      return this.externalApp;
    }
  }, {
    key: "isServe",
    value: function isServe() {
      return process.env.WEBPACK_SERVE;
    }
  }, {
    key: "isProduction",
    value: function isProduction() {
      return process.env.NODE_ENV && process.env.NODE_ENV === 'production';
    }
  }, {
    key: "t",
    value: function t(category, message) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.translate.format(category, message, params);
    }
  }, {
    key: "tForReact",
    value: function tForReact(category, message) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.translate.formatForReact(category, message, params);
    }
  }, {
    key: "getUser",
    value: function getUser() {
      return this.user;
    }
  }, {
    key: "priceRound",
    value: function priceRound(value) {
      return Number(Number(value).toFixed(2));
    }
  }, {
    key: "priceFormat",
    value: function priceFormat(price) {
      var currency = this.getUser().getCurrency();
      var result = '';

      if (currency.symbolLeft) {
        result += currency.symbolLeft;
      }

      result += numberFormat(this.priceRound(price), currency.decimalPlace, '.', ' ');

      if (currency.symbolRight) {
        result += " ".concat(currency.symbolRight);
      }

      return result;
    }
  }]);

  return App;
}();

var translate = container.get(TYPES.Translate);
var user = container.get(TYPES.User);
var app = new App(translate, user);
window.app = app;
export default app;
export { App };